import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface SearchCategoryItem {
  name: 'Customer' | 'Contact' | 'Project' | 'Invoice' | 'Employee';
  isSelected: boolean;
}

type SearchAction =
  | {
      type:
        | 'TOGGLE_SEARCH'
        | 'TOGGLE_CATEGORY'
        | 'RESET_SEARCH'
        | 'CLOSE_CATEGORY';
    }
  | { type: 'UPDATE_CATEGORY_LIST'; payload: SearchCategoryItem[] };

interface SearchStore {
  isMainSearchOpen: boolean;
  isCategoryOpen: boolean;
  categoryList: SearchCategoryItem[];
  updateStore: (action: SearchAction) => void;
  hasAccessToSearch: () => boolean;
  hasActiveCategoryFilters: () => boolean;
  getCategoryListString: () => string;
  getSelectedCategoryList: () => string[];
}

const updateStoreValue = (set, action: SearchAction) => {
  set(
    (state: SearchStore) => {
      switch (action.type) {
        case 'RESET_SEARCH':
          return {
            ...state,
            isMainSearchOpen: false,
            isCategoryOpen: false,
          };
        case 'TOGGLE_SEARCH':
          return {
            ...state,
            isMainSearchOpen: !state.isMainSearchOpen,
            isCategoryOpen:
              !state.isMainSearchOpen === false ? false : state.isCategoryOpen,
          };
        case 'TOGGLE_CATEGORY':
          return {
            ...state,
            isCategoryOpen: !state.isCategoryOpen,
          };
        case 'CLOSE_CATEGORY':
          return {
            ...state,
            isCategoryOpen: false,
          };
        case 'UPDATE_CATEGORY_LIST':
          return {
            ...state,
            categoryList: action.payload,
          };
        default:
          return state;
      }
    },
    undefined,
    'search/update',
  );
};

export const useSearchStore = create<SearchStore>()(
  devtools((set, get) => ({
    isMainSearchOpen: false,
    isCategoryOpen: false,
    categoryList: [],
    updateStore: (action: SearchAction) => updateStoreValue(set, action),
    hasActiveCategoryFilters: () =>
      get().categoryList?.some((el) => el.isSelected),
    getCategoryListString: () =>
      get()
        .categoryList?.map(({ name, isSelected }) => (isSelected ? name : ''))
        .filter((name) => !!name)
        .join(',') || '',
    getSelectedCategoryList: () =>
      get()
        .categoryList?.filter(({ isSelected }) => isSelected)
        .map(({ name }) => name) || [],
  })),
);
